import { ɵRuntimeError } from '@angular/core';
import { ErrorPacket, Next, Pipe } from '../types';
import { ErrorConverterService } from '../../services/error-converter.service';

export class RuntimeErrorPipe implements Pipe<ErrorPacket, ErrorPacket> {
    public constructor(private readonly errorConverter: ErrorConverterService) {}

    public handle(packet: ErrorPacket, next: Next<ErrorPacket, ErrorPacket>): ErrorPacket {
        if (packet.result) return next(packet);

        if (!(packet.data instanceof ɵRuntimeError)) {
            return next(packet);
        }

        return {
            ...packet,
            result: this.errorConverter.getAppErrorFromRuntimeError(packet.data),
        };
    }
}
